<template>
  <div class="headerSuppliers">
    <h1>Lista de Proveedores</h1>

    <v-data-table :headers="headers" :items="suppliers" :header-props="{ class: 'red-header' }" :search="searchTerm">
      <template v-slot:top>
        <div style="margin-bottom: 50px">
          <div class="row justify-space-between mx-auto">
            <v-text-field label="Buscador" placeholder="Ingrese por favor una palabra" append-icon="mdi-magnify" dense
              outlined class="col-md-5" @input="search"></v-text-field>
            <div class="btn">
              <addSuppliers />
            </div>
          </div>
        </div>
      </template>

      <template v-slot:[`item.icon`]="{ item }">
        <img :src="item.icon" />
      </template>

      <template v-slot:[`item.nameSupplier`]="{ item }">
        <span class="custom-font">{{ item.nameSupplier }}</span>
      </template>

      <template v-slot:[`item.identificationNumber`]="{ item }">
        <span class="custom-font">{{ item.identificationNumber }}</span>
      </template>

      <template v-slot:[`item.adviser`]="{ item }">
        <span class="custom-font">{{ item.adviser }}</span>
      </template>

      <template v-slot:[`item.email`]="{ item }">
        <span class="custom-font">{{ item.email }}</span>
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <!-- Botón de acción para abrir el diálogo de detalles  -->
        <v-icon color="primary" size="x-large"></v-icon>

        <div class="actions">

          <detailsSuppliers :status="item.activeDialogClient" :companyProps="item" style="margin-left:1vh"><v-btn icon
              x-large dark text>
              <v-icon class="mt-2" color="primary">mdi-border-color</v-icon>
            </v-btn>
          </detailsSuppliers>

          <v-btn class="btnDetails" icon x-large dark text @click="deleteSuppliers(item.supplierId)"
            style="background-color: transparent; margin-left:1vh">
            <v-icon color="primary">mdi-delete</v-icon>
          </v-btn>
        </div>
      </template>

    </v-data-table>

  </div>
</template>

<script>
import addSuppliers from "@/views/suppliers/pages/add_suppliers/add_suppliers_page.vue";
import detailsSuppliers from "@/views/suppliers/pages/detail_suppliers/detail_suppliers_page.vue";
import EventBus from '@/utils/event_bus.js';
import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2";

import {
  SUPPLIERS_M,
  GET_SUPPLIERS,
  ACTION_GET_SUPPLIERS,
  ACTION_DELETE_SUPPLIERS,
} from "@/views/suppliers/store/types/types.js";

export default {
  name: "listCategoriaComponent",
  components: {
    addSuppliers,
    detailsSuppliers
  },

  data() {
    return {
      searchTerm: "",
    };
  },

  async mounted() {

    await this.getActionSuppliers();

    EventBus.$on('reload-suppliers', async () => {
      await this.reloadSuppliers();
    });

    EventBus.$on('formSuppliers-submitted-successfully', async () => {
      await this.reloadSuppliers();
    });

    EventBus.$on('reload-update-suppliers', async () => {
      await this.reloadSuppliers();
    });

    EventBus.$on('reload-delete-suppliers', async () => {
      await this.reloadSuppliers();
    });

  },

  methods: {

    ...mapActions({
      getActionSuppliers: `${SUPPLIERS_M}${ACTION_GET_SUPPLIERS}`,
      deleteActionSuppliers: `${SUPPLIERS_M}${ACTION_DELETE_SUPPLIERS}`,
    }),

    async reloadSuppliers() {
      await this.getActionSuppliers();
    },

    search() {
      this.searchTerm = event.target.value;
    },

    async deleteSuppliers(supplierId) {
          const result = await Swal.fire({
            title: '¿Estás seguro?',
            text: 'Esta acción no se puede deshacer.',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#6E17A5'
          });
  
          if (result.isConfirmed) {
            
            await this.deleteActionSuppliers(supplierId);
            this.getActionSuppliers()
            
          } else {
            Swal.fire({
              position: 'top-end',
              icon: 'info',
              title: 'La acción ha sido cancelada.',
              showConfirmButton: false,
              timer: 2500
            }); 
          }
      },

  },

  computed: {
    ...mapGetters({
      suppliers: [`${SUPPLIERS_M}${GET_SUPPLIERS}`],
    }),

    headers() {
      return [
        {
          value: "icon",
          align: "center",
          sortable: false,
          class: "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          text: "Nombre Proveedor",
          value: "nameSupplier",
          align: "center",
          sortable: false,
          class: "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          text: "Identificación",
          value: "identificationNumber",
          align: "center",
          sortable: false,
          class: "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          text: "Nombre Asesor",
          value: "adviser",
          sortable: false,
          align: "center",
          class: "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          text: "Correo",
          value: "email",
          align: "center",
          sortable: false,
          class: "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          value: "action",
          sortable: false,
          align: "center",
        },
      ];
    },
  },

};
</script>

<style lang="css" scoped>
.headerSuppliers h1 {
  margin-bottom: 30px;
}

.headerSuppliers {
  display: flex;
  gap: 40px;
  flex-direction: column;
  margin-top: 20px;
  margin-left: 20px;
}

.actions v-icon {
  font-size: 24px;
}

.custom-font {
  font-size: 20px;
}

/* Define los estilos (Tipo de letra) para las etiquetas h1,h2,h3,h4,h5,h6   */
body {
  font-family: "Nunito Sans", sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Amsi Pro", sans-serif;
  color: #2d0049;
  font-weight: normal;
}

/* Estilos para el botón de eliminar */
.btnDetails .v-icon {
  color: #6E17A5;
  margin-bottom: 19px;
}

/**estilo de los iconos */
.actions {
  display: flex;

}

/* .marginIcon{
      margin-top: 12;
    } */

img {
  width: 3rem;
  height: 3rem;
}

@media screen and (max-width: 414px) {

  h1 {
    font-size: 3vh;
    margin-left: 2vh
  }

  .custom-font {
    font-size: 13px;
  }

  img {
    margin-top: 18px;
    margin-bottom: auto;
    width: 3rem;
    height: 3rem;
  }
}

@media screen and (min-width: 414px) {

  h1 {
    font-size: 4vh;
    margin-left: 2vh
  }

}

@media screen and (max-width: 280px) {

  h1 {
    font-size: 3vh;
    margin-left: 2vh
  }

  h2 {
    font-size: 2vh;
  }

  .custom-font {
    font-size: 13px
  }

  img {
    margin-top: 20px;
    margin-bottom: 10px;
    width: 3rem;
    height: 3rem;
  }
}
</style>